<template>
  <li class="acc-item">
    <a-icon v-if="isPC" :type="idx === 'notice' ? 'pushpin' : isOpen ? 'down' : 'up'" />
    <h2 @click="onSwitch">
      <p class="title">
        <a-badge v-if="!isRead && idx !== 'notice'" dot />
        {{ title }}
      </p>
      <p class="detail" v-if="idx !== 'notice'">
        <b>{{ author.username }}</b>님
        <a-popover>
          <template slot="content">
            <span>
              <b>읽은 회원</b>
            </span>
            <p v-for="(read, index) in reads" :key="index">{{ read.username }}</p>
          </template>
          <a-icon
            style="position: inherit; color: #777; font-size: 12px; margin-top: 0px;"
            type="team"
          />
        </a-popover>
        <span />
        {{ uploadAt.format('LLL') }} ({{ uploadAt.fromNow() }})
        <a
          class="a_type_2"
          @click="onDelete"
        >삭제</a>
      </p>
      <p class="detail" v-else>공지 사항</p>
    </h2>
    <div v-if="isOpen">
      <div class="cmt-content">
        <div class="acc-content">
          <vue-markdown>{{ contents }}</vue-markdown>
          <a-divider
            v-if="idx !== 'notice'"
            orientation="left"
            style="margin-top: 0px; color: #777; font-size: 14px;"
          >댓글</a-divider>
          <ul style="margin: 3px;" v-if="comments.length > 0 && idx !== 'notice'">
            <BroadcastComment
              v-for="(comment, index) in comments"
              :key="index"
              :idx="idx"
              :editingIdx="editingIdx"
              :commentIdx="comment.idx"
              :uploadAt="$moment(comment.uploadAt)"
              :author="comment.author"
              :contents="comment.contents"
              :refreshComments="refreshComments"
              :setEditingMode="setEditingMode"
              :isMine="comment.author.idx === $store.state.auth.idx"
            />
          </ul>
          <span
            v-else-if="idx !== 'notice'"
            style="color: #777; font-size: 14px; margin: 10px;"
          >아직 댓글이 없습니다. 가장 먼저 작성하여 보세요.</span>
        </div>
        <a-comment v-if="idx !== 'notice'">
          <div slot="content">
            <a-form-item>
              <a-textarea :rows="4" v-model="message"></a-textarea>
            </a-form-item>
            <a-form-item>
              <a-button @click="onComment" type="primary">댓글 {{ editingIdx === '' ? '달기' : '수정' }}</a-button>
            </a-form-item>
          </div>
        </a-comment>
      </div>
    </div>
  </li>
</template>
<script>
import VueMarkdown from "vue-markdown";
import config from "../../config";
import Axios from "axios";
import AxiosMiddleware from "../../libs/AxiosMiddleware";
import OPCODE from "../../libs/OPCODE";
import BroadcastComment from "./BroadcastComment";
import { mapActions } from "vuex";

export default {
  name: "BroadcastCard",
  props: ["idx", "isOpen", "title", "author", "uploadAt", "reads", "contents"],
  components: { VueMarkdown, BroadcastComment },
  data() {
    let isRead = false;
    const idx = this.$store.state.auth.idx;
    if (this.isOpen) this.refreshComments();
    for (const readed of this.reads) {
      if (readed.idx === idx) {
        isRead = true;
        break;
      }
    }
    return { isRead, comments: [], message: "", editingIdx: "" };
  },
  methods: {
    ...mapActions(["refreshBroadcast"]),
    onDelete() {
      const self = this;
      this.$confirm({
        title: `“${this.title}”`,
        content: "정말로 해당 글을 삭제하시겠습니까?",
        okText: "네, 삭제합니다.",
        okType: "danger",
        cancelText: "아니요",
        onOk() {
          self.onDeleteReq();
        },
        onCancel() {}
      });
    },
    async onDeleteReq() {
      const { data } = await Axios.delete(
        `${config.hostname}/v1/broadcast/${this.idx}`,
        {
          withCredentials: true
        }
      );

      if (AxiosMiddleware(data.opcode)) {
        switch (data.opcode) {
          case OPCODE.SUCCESS:
            this.refreshBroadcast();
            config.alert.mixin({
              type: "success",
              title: "성공적으로 삭제되었습니다."
            });
            break;
        }
      }
    },
    setEditingMode(idx, contents) {
      if (this.editingIdx !== idx) {
        this.editingIdx = idx;
        this.message = contents;
      } else {
        this.editingIdx = "";
        this.message = "";
      }
    },
    async onComment() {
      if (this.message.length < 3) {
        return config.alert.mixin({
          type: "warning",
          title: "최소 3자리 이상 입력하여 주세요."
        });
      }

      const { data } = await Axios.post(
        `${config.hostname}/v1/broadcast/comment/${this.idx}/${this.editingIdx}`,
        { contents: this.message },
        { withCredentials: true }
      );

      if (AxiosMiddleware(data.opcode)) {
        switch (data.opcode) {
          case OPCODE.SUCCESS:
            await this.refreshComments();
            this.editingIdx = "";
            this.message = "";
            break;
        }
      }
    },
    async refreshComments() {
      try {
        if (this.idx === "notice") return;
        const {
          data
        } = await Axios.get(
          `${config.hostname}/v1/broadcast/comment/${this.idx}`,
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.comments = data.comments;
              break;
          }
        }
      } catch (e) {
        config.alert.mixin({
          type: "error",
          title: "댓글을 가져올 수 없습니다.\n인터넷 상태를 확인해주세요."
        });
      }
    },
    onSwitch() {
      if (this.isOpen) {
        this.$router.push("/broadcast");
      } else {
        this.refreshComments();
        this.$router.push("/broadcast/" + this.idx);
      }
    }
  }
};
</script>
